import React, { Component } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Link } from "react-router-dom";
import { getparkedFileList } from "../../actions/parkedfileaction";
import Header from "../../component/common/Header";
import CONSTANT from "../../constant";
import { getCookie, onChange, setValue } from "../../utils";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AddCircular,
  AddCircularAttachment,
  getAccessList,
} from "../../actions/Circular";
import constant from "../../constant";
import Loader from "./../common/Loader";

export default class CircularList extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const date = today.setDate(today.getDate());
    const defaultValue = new Date(date).toISOString().split("T")[0];

    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    let departmentObj = {
      departmentCode: userDetail.departmentCode,
      departmentName: userDetail.departmentName,
    };

    this.state = {
      CircularNumber: {
        name: "CircularNumber",
        value: ``,
        error: "",
        isRequired: true,
      },

      dateOfUpload: {
        name: "dateOfUpload",
        value: `${defaultValue}`,
        error: "",
        isRequired: true,
      },
      IssuedBy: {
        name: "IssuedBy",
        value: "",
        options: [departmentObj],
        error: "",
        isRequired: true,
      },
      TitleOfCircular: {
        name: "TitleOfCircular",
        value: "",
        error: "",
        isRequired: true,
      },
      Keywords: { name: "Keywords", value: "", error: "", isRequired: true },
      Uploads: { name: "Uploads", value: [], error: "", isRequired: true },

      page: 1,
      limit: 100,
      pending: undefined,
      list: undefined,
      userDetail,
      showLoader: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.successMessage = this.successMessage.bind(this);
  }

  getparkedFileList() {
    getparkedFileList()
      .then((p_data) => {
        if (p_data) {
          this.setState({ ...this.state, list: p_data.result });
        }
      })
      .catch((err) => {
        // alert("some error occured ")
      });
  }

  openDetailPage = (url) => {
    this.props.history.push(url);
  };

  componentDidMount() {
    const { userDetail } = this.state;

    getAccessList()
      .then((res) => {
        if (res.status == constant.static.apiStatus.success) {
          if (res.result.some((ele) => ele.code == userDetail.code)) {
            // access grated
          } else {
            // else return to list page
            this.erroMessage(" not authorised user to create circular ");
            this.props.history.push(constant.component.circularList.url);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        this.props.history.push(constant.component.circularList.url);
      });
  }

  async PromiseAttachments(fileCode, IssuedBy, dateOfUpload, Uploads) {
    let all_files = await Promise.all(
      Array.from(Uploads.value).map(async (val, i) => {
        let fd = new FormData();
        fd.append("fileCode", fileCode);
        fd.append("deptCode", IssuedBy.value[0].departmentCode);
        fd.append("dateOfUpload", dateOfUpload.value);
        fd.append("attachment", val);
        let res = AddCircularAttachment(fd);
        return res;
      })
    );

    if (all_files.every((_) => _.status == constant.static.apiStatus.success)) {
      this.successMessage(" Circular intiated  ");
      this.setState({ ...this.state, showLoader: false });
      this.props.history.push(constant.component.circularList.url);
    } else {
      this.erroMessage(
        all_files.find((_) => _.status != constant.static.apiStatus.success)
          .error
      );
      this.setState({ ...this.state, showLoader: false });
    }
  }

  onSubmit(states) {
    const {
      CircularNumber,
      dateOfUpload,
      IssuedBy,
      TitleOfCircular,
      Keywords,
      Uploads,
      userDetail: { code: userCode },
    } = states;

    let model = {
      CircularNumber,
      dateOfUpload,
      IssuedBy,
      TitleOfCircular,
      Keywords,
      TitleOfCircular,
    };

    this.setState({ ...this.state, showLoader: true });
    let status = this.varifyform(model);
    if (status) {
      // create a circular model and hit the api
      let dataModel = {
        CircularNumber: CircularNumber.value,
        CircularTitle: TitleOfCircular.value,
        dateOfUpload: dateOfUpload.value,
        Department: IssuedBy.value[0].departmentCode,
        Keyword: Keywords.value,
      };

      AddCircular(dataModel)
        .then((res) => {
          if (res.status) {
            if (Uploads.value.length != 0) {
              // uploading files
              this.PromiseAttachments(
                res.result.fileCode,
                IssuedBy,
                dateOfUpload,
                Uploads
              );
              // uploading files
            } else {
              this.setState({ ...this.state, showLoader: false });
              this.successMessage(" circular intiated with 0 number of files ");
              this.props.history.push(constant.component.circularList.url);
            }
          }
        })
        .catch((err) => {
          this.setState({ ...this.state, showLoader: false });
          this.erroMessage(`${err}`);
        });
    } else {
      // show required field error
      this.setState({ ...this.state, showLoader: false });
    }
  }

  varifyform(states) {
    let status = true;
    for (let [key, valObj] of Object.entries(states)) {
      if (!valObj.value) {
        status = false;
        this.erroMessage(`please enter ${key} `);
      }
    }

    return status;
  }

  onChange(e) {
    const { Uploads } = this.state;
    const { name, value } = e.target;

    if (name == Uploads.name) {
      // setting binary data of file

      onChange(this, Uploads.name, e.target.files);
    } else {
      this.setState({
        ...this.state,
        [name]: { ...this.state[name], value: value, error: "" },
      });
    }
  }

  dltItem = (index, array) => {
    let finalArray = array.splice(index, 1);
    setValue(this, this.state.Uploads.name, array);
  };

  onBlur(e) {
    const { name, value } = e.target;
    if (!value) {
      this.setState({
        ...this.state,
        [name]: { ...this.state[name], error: "true" },
      });
    }
  }

  typeaheadOnChange(name, issuedByObject) {
    // object of array of issued by
    setValue(this, this.state.IssuedBy.name, issuedByObject);
  }

  render() {
    const { page, limit, list, userDetail, showLoader } = this.state;
    const dltFile = this;
    const {
      CircularNumber,
      dateOfUpload,
      IssuedBy,
      TitleOfCircular,
      Keywords,
      Uploads,
    } = this.state;

    return (
      <React.Fragment>
        {showLoader && <Loader />}

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card homedob p-4 mb-4">
                <div className="row">
                  <div className="col-md-8">
                    <h3 className="page-title">Add Circular</h3>
                  </div>

                  <div className="col-md-4 text-end">
                    <Link
                      to={CONSTANT.component.circularList.url}
                      className="btn-back-home"
                    >
                      <h2> Go Back </h2>
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 mt-3">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              Circular Number #{" "}
                              <small className="text-danger">*</small>
                            </label>
                            <input
                              type="text"
                              className={
                                CircularNumber.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="File number"
                              name={CircularNumber.name}
                              value={CircularNumber.value}
                              onChange={this.onChange}
                              onBlur={this.onBlur}
                            />
                          </div>

                          {CircularNumber.error.length > 0 && (
                            <small className="text-danger">
                              {" "}
                              please enter circular number{" "}
                            </small>
                          )}
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              Issued On <small className="text-danger">*</small>
                            </label>
                            <input
                              disabled={true}
                              type="date"
                              defaultValue={dateOfUpload.value}
                              className={
                                dateOfUpload.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Date of upload"
                              name={dateOfUpload.name}
                              value={dateOfUpload.value}
                              // onChange={this.onChange}
                              // onBlur={this.onBlur}
                            />
                          </div>

                          {dateOfUpload.error.length > 0 && (
                            <small className="text-danger">
                              {" "}
                              please enter date{" "}
                            </small>
                          )}
                        </div>

                        <div className="col-md-6">
                          <div className="form-group mb-2">
                            <label>
                              Select Department <small>(Optional)</small>
                            </label>

                            <Typeahead
                              id="ta-recipient"
                              flip={true}
                              multiple={true}
                              labelKey={(option) =>
                                `${option.departmentName} - ${option.departmentCode}`
                              }
                              name={IssuedBy.name}
                              value={IssuedBy.value}
                              options={IssuedBy.options}
                              onChange={(e) =>
                                this.typeaheadOnChange(IssuedBy.name, e)
                              }
                              placeholder=""
                              isInvalid={IssuedBy.error.length > 0}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Title</label>
                            <input
                              type="text"
                              className={
                                TitleOfCircular.error.length > 0
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder="Title"
                              name={TitleOfCircular.name}
                              value={TitleOfCircular.value}
                              onChange={this.onChange}
                              onBlur={this.onBlur}
                            />
                          </div>
                          {TitleOfCircular.error.length > 0 && (
                            <small className="text-danger">
                              {" "}
                              please enter title{" "}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Keywords</label>
                        <textarea
                          type="text"
                          rows="10"
                          cols="50"
                          className={
                            Keywords.error.length > 0
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          placeholder="Keywords"
                          name={Keywords.name}
                          value={Keywords.value}
                          onChange={this.onChange}
                          onBlur={this.onBlur}
                        />
                      </div>

                      {Keywords.error.length > 0 && (
                        <small className="text-danger">
                          {" "}
                          please enter keyword{" "}
                        </small>
                      )}
                    </div>

                    {Array.from(Uploads.value).length > 0 && (
                      <div className="col-md-12">
                        {Array.from(Uploads.value).map((ele, index, array) => (
                          <span
                            key={index}
                            className="badge badge-primary mr-1 dlt_file "
                          >
                            {ele.name}
                            <i
                              onClick={(e) => {
                                dltFile.dltItem(index, array);
                              }}
                              className="fa fa-times "
                              style={{ color: "red" }}
                              aria-hidden="true"
                            />
                          </span>
                        ))}
                      </div>
                    )}

                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-9">
                          <label>Attachments</label>

                          <input
                            type="file"
                            multiple
                            className={
                              Uploads.error.length > 0
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder="files"
                            name={Uploads.name}
                            onChange={(e) => this.onChange(e)}
                            //    onBlur={this.onBlur}
                          />
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <button
                              onClick={() => this.onSubmit(this.state)}
                              className="btn btn-block submit-button btn-sm mt-3 p-2"
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    );
  }

  erroMessage(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  successMessage(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
}
